import angular from 'angular'
import taxControlCtrl from './list'
import listPage from './view/list.html'


function configRouter($stateProvider) {
    $stateProvider.state(
        'system.basedata.taxControl',
        {
            url: '/taxControl',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'system.basedata.taxControl.list',
            title: '税控设备管理',
        },
    )
    $stateProvider.state(
        'system.basedata.taxControl.list',
        {
            url: '/list',
            template: listPage,
            controller: 'taxControlCtrl',
        },
    )
}

export default angular
    .module('system.syssetting.taxControl', [])
    .config(['$stateProvider', configRouter])
    .controller('taxControlCtrl', taxControlCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxControl/index.js